import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { PropOptions } from '@lib/form/shared/prop-options.interface';

@Component({
  selector: 'app-formly-label-wrapper',
  template: `
    <div
      [ngClass]="templateOptions.wrapperClass"
      class="flex flex-col  rounded-lg mb-10 bg-white shadow-sm"
    >
      <div
        [ngClass]="templateOptions.containerClass"
        class="mb-3 text-xl font-medium pt-5  pl-5 pr-3 rounded-t"
      >
        <span>{{ props.label || 'Label here ' }}</span>
      </div>

      <div class="flex flex-col px-5 pt-3">
        <ng-container #fieldComponent></ng-container>
      </div>
    </div>
  `,
})
export class FormlyLabelWrapper extends FieldWrapper {
  get templateOptions(): PropOptions {
    return this.props as PropOptions;
  }
}
